import { ReactNode } from "react";
import { SanitizeHTML } from "../../global/SanitizeHTML";

interface ICodeSlide {
  title: string;
  subtitle?: string;
  language: string;
  children: ReactNode;
}

export default function CodeSlide({ title, subtitle = '', language, children }: ICodeSlide) {
  const codeLanguage = `hljs ${language}`
  return (
    <section>
      <h2>{title}</h2>
      <pre data-id="code-animation">
        <code className={codeLanguage} data-trim data-line-numbers>
          {children}
        </code>
      </pre>
      <SanitizeHTML html={subtitle}></SanitizeHTML>
    </section>
  );
}
